"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IaBeatUtil = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const IAValidator_1 = require("./IAValidator");
class IaBeatUtil {
    /**
     * Get the default IA Filling for the given Kette.
     * The calculation takes the Kette System and the Montage direction into account.
     */
    static getDefaultBeat(ketteJson) {
        if (!(ketteJson === null || ketteJson === void 0 ? void 0 : ketteJson.KetteSerieType)) {
            return Object.assign({}, this.defaultBeatByKetteSerieType.default);
        }
        const defaultBeat = Object.assign({}, this.defaultBeatByKetteSerieType[ketteJson.KetteSerieType]);
        if (ketteJson.Halbstegig && ketteJson.NumGlieder && ketteJson.EchainSystem) {
            const isEvenGlieder = ketteJson.NumGlieder % 2 === 0;
            const systemGroup = (0, echain_shared_articles_1.findKettenSystemGroup)(ketteJson);
            // overwrite the startingAt for some cases
            if (ketteJson.IsMontageMitnehmer) {
                if (systemGroup === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E61_OR_E6) {
                    defaultBeat.startingAt = 2;
                }
                else if (!isEvenGlieder && systemGroup === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E4_4_OR_E4_light) {
                    defaultBeat.startingAt = 2;
                }
            }
            else {
                if (isEvenGlieder && systemGroup === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E4_1_OR_E4_00) {
                    defaultBeat.startingAt = 2;
                }
                else if (!isEvenGlieder && systemGroup === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E61_OR_E6) {
                    defaultBeat.startingAt = 2;
                }
                else if (systemGroup === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E4_4_OR_E4_light) {
                    defaultBeat.startingAt = 2;
                }
            }
        }
        return defaultBeat;
    }
    static getDefaultBeatByKetteSerieType(ketteSerieType) {
        return Object.assign({}, this.defaultBeatByKetteSerieType[ketteSerieType]);
    }
    static getDefaultSmartPlasticBeats() {
        return (0, echain_shared_ts_utils_1.clonePrimitive)(this.defaultSmartPlasticBeats);
    }
    /**
     * Retrieves the EvenOdd beats for a Kette
     */
    static getEvenOddBeatsByKette(ketteJson) {
        const defaultBeat = this.getDefaultBeat(ketteJson);
        // normal Kette every 2nd, halbstegige Kette every 4th link
        const perNth = (ketteJson === null || ketteJson === void 0 ? void 0 : ketteJson.Halbstegig) ? 4 : 2;
        return [
            {
                startingAt: defaultBeat.startingAt,
                perNth,
            },
            {
                startingAt: defaultBeat.startingAt + ((ketteJson === null || ketteJson === void 0 ? void 0 : ketteJson.Halbstegig) ? 2 : 1),
                perNth,
            },
        ];
    }
    /**
     * returns array of boolean there the index of the position in array match to the Gliednumber of
     * Kette and the value of ia position returns the state if Glied has IA true => Glied has IA
     * false => Glied hasn't IA
     *
     * The perspective is from Festpunkt
     */
    static getListWhichGliedHasIA(ia, kette) {
        var _a;
        return (_a = this.getCountOfIAsPerLink({
            article: ia,
            count: 1,
        }, kette)) === null || _a === void 0 ? void 0 : _a.map((iaPerLink) => Boolean(iaPerLink));
    }
    /**
     * returns an array of ia-counts per link (if it can be calculated)
     * if not, we return undefined
     */
    static getCountOfIAsPerLink(iaGroup, kette) {
        var _a;
        const ia = iaGroup.article;
        if (ia.manualCount || !ia.startingAtNthKettenglied || !ia.perNthKettenglied) {
            return undefined;
        }
        if (IAValidator_1.IAValidator.validateCountForKette(ia, kette).hasIssues()) {
            return undefined;
        }
        const isHalbstegig = kette.halbstegig;
        if (isHalbstegig) {
            // it's actual the same logic.. (now?)
            // TODO: EKE-10352- check ia beat calculations with different views/halbstegige ketten!!
        }
        const numKettenglieder = (_a = kette.numGlieder) !== null && _a !== void 0 ? _a : 0;
        const iasPerLink = new Array(numKettenglieder).fill(0);
        const offsetKettenglieder = ia.startingAtNthKettenglied - 1;
        for (let i = offsetKettenglieder; i < numKettenglieder; i += ia.perNthKettenglied) {
            iasPerLink[i] = iaGroup.count;
        }
        return iasPerLink;
    }
    static isSameBeat(a, b) {
        // same instance or both undefined?
        if (a === b)
            return true;
        // just one undefined?
        if (!a || !b)
            return false;
        return a.startingAt === b.startingAt && a.perNth === b.perNth;
    }
    static iaToBeat(ia) {
        if (ia.StartingAtNthKettenglied == null || ia.PerNthKettenglied == null)
            return undefined;
        return {
            startingAt: ia.StartingAtNthKettenglied,
            perNth: ia.PerNthKettenglied,
        };
    }
    static areInSync(a, b) {
        const beatA = this.iaToBeat(a);
        const beatB = this.iaToBeat(b);
        return this.isSameBeat(beatA, beatB);
    }
    static isInBeat(ia, beat) {
        const isStaticIA = (iaJson) => {
            // static ia's have no article type
            return !iaJson.ArticleType;
        };
        // static IAs are always there, in any beat
        if (isStaticIA(ia))
            return true;
        return this.isSameBeat(this.iaToBeat(ia), beat);
    }
    // is this still universal if it does different things for different inputs? universal in a name feels bad
    static getUniversalBeatTexts(iaBeat, options = {}) {
        var _a, _b, _c;
        let modifierDE = 'Innenaufteilung';
        let modifierEN = 'Internal shelving';
        if (((_a = options.espool) === null || _a === void 0 ? void 0 : _a.position) === echain_shared_articles_1.EspoolChainPosition.left) {
            modifierDE = 'Linkes Twisterband';
            modifierEN = 'Left Twisterband';
        }
        else if (((_b = options.espool) === null || _b === void 0 ? void 0 : _b.position) === echain_shared_articles_1.EspoolChainPosition.right) {
            modifierDE = 'Rechtes Twisterband';
            modifierEN = 'Right Twisterband';
        }
        const prelude = [iaBeat.startingAt, iaBeat.startingAt + iaBeat.perNth, iaBeat.startingAt + 2 * iaBeat.perNth].join(',') + '..';
        let text;
        if (iaBeat.perNth === 0) {
            text = {
                de: `${modifierDE} nur im  ${iaBeat.startingAt} Glied`,
                en: `${modifierEN} only in ${iaBeat.startingAt} link`,
            };
        }
        else {
            text = {
                de: `${modifierDE} beginnend im ${iaBeat.startingAt} Glied, montiert in jedem ${iaBeat.perNth} Glied (${prelude})`,
                en: `${modifierEN} starting in ${iaBeat.startingAt} link, mounted in every ${iaBeat.perNth} link (${prelude})`,
            };
        }
        // add Espool replacement note
        if (((_c = options.espool) === null || _c === void 0 ? void 0 : _c.position) === echain_shared_articles_1.EspoolChainPosition.linear && options.espool.replacement) {
            const { artNr, perNth } = options.espool.replacement;
            text.de += `, je ${perNth} Glied Art.Nr. ${artNr}`;
            text.en += `, each ${perNth} link Part.No. ${artNr}`;
        }
        return text;
    }
    static getAllBeats(ias) {
        return ias.reduce((beats, ia) => {
            const iaBeat = this.iaToBeat(ia);
            if (!iaBeat) {
                return beats;
            }
            if (beats.some((beat) => this.isSameBeat(beat, iaBeat))) {
                return beats;
            }
            beats.push(iaBeat);
            return beats;
        }, new Array());
    }
}
exports.IaBeatUtil = IaBeatUtil;
IaBeatUtil.className = 'IaBeatUtil';
IaBeatUtil.defaultBeatByKetteSerieType = {
    [echain_shared_articles_1.KetteSerieType.default]: {
        startingAt: 1,
        perNth: 2,
    },
    [echain_shared_articles_1.KetteSerieType.eskin]: {
        startingAt: 2,
        perNth: 1,
    },
    [echain_shared_articles_1.KetteSerieType.twisterband]: {
        startingAt: 1,
        perNth: 4,
    },
    [echain_shared_articles_1.KetteSerieType.twisterchain]: {
        startingAt: 1,
        perNth: 2,
    },
    [echain_shared_articles_1.KetteSerieType.rxRohr]: {
        startingAt: 1,
        perNth: 2,
    },
    [echain_shared_articles_1.KetteSerieType.triflexR]: {
        startingAt: 0,
        perNth: 0,
    },
    [echain_shared_articles_1.KetteSerieType.trxe]: {
        startingAt: 0,
        perNth: 0,
    },
    // todo check EKE-10745
    [echain_shared_articles_1.KetteSerieType.rolEchain]: {
        startingAt: 1,
        perNth: 2,
    },
};
IaBeatUtil.defaultSmartPlasticBeats = [
    { startingAt: 1, perNth: 0 },
    { startingAt: 2, perNth: 2 },
];
//# sourceMappingURL=IaBeatUtil.js.map